/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-return */
import LocalesKeyObject from "@locales/key";
import { useDangerousHTMLSafely } from "@locales/hooks";
import type { TLocalesI18n } from "@locales/types";

/**
 * @description
 * - the typesafe object for accessing the global `I18n` object, the `i` is on purpose lowercase.
 * - currently supports `t` = translation, `getLocale` = get current locale, `setLocale` = set current locale, `tInter` = translation with interpolation.
 * - if you need more advanced styling options for interpolated strings, take a look at the `useDangerousHTMLSafely` hook.
 * - if type error occurs, check readme.md for info how to update the Key.
 * @example
 * // explicit import with type checking --> good
 * import { i18n } from "@locales";
 * i18n.t("events.countdown.title");
 * // global access without type checking --> bad
 * I18n.t("events.countdown.title");
 * // note the `I` is uppercase, this is the global object, not the typed wrapper.
 * @requires
 * - including the `localize` pack from sprockets into the slim / erb layout file / or the given template hierarchy already includes necessary deps (see: app/javascript/src/locales/readme.mdx).
 * - for storybook and vite, it should be good to go, there is some magic happening in the background, see: app/javascript/vite/storybook/readme.mdx
 */
const i18n: TLocalesI18n = {
  // @ts-expect-error - we cannot reference the global `I18n` object directly, because we assume its either hoisted by vite / storybook or sprockets (even for webpack nviroment)
  t: (key) => I18n.t(key),
  // @ts-expect-error - same as above
  tInter: (arg) => I18n.t(arg[0], arg[1]),
  // @ts-expect-error - same as above
  getLocale: I18n.locale,
  setLocale(locale) {
    // @ts-expect-error - same as above
    I18n.locale = locale;
  },
};

export { i18n, LocalesKeyObject as K, useDangerousHTMLSafely };
